import React from 'react';
import ErrorBoundary from '../components/ErrorBoundary';

/**
 * Legal Page
 * Single Responsibility: Display legal information and links
 */
const Legal = () => {
  return (
    <ErrorBoundary section="Legal">
      <div className="min-h-screen bg-gray-50">
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Legal Information</h1>
            <p className="text-xl text-gray-600">
              Important legal documents and information
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow p-8 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Legal Documents</h2>
              <div className="space-y-4">
                <a href="/legal/privacy-policy" className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-semibold text-gray-900">Privacy Policy</h3>
                      <p className="text-sm text-gray-600 mt-1">How we collect, use, and protect your personal information</p>
                    </div>
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </a>

                <a href="/legal/terms-of-service" className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-semibold text-gray-900">Terms of Service</h3>
                      <p className="text-sm text-gray-600 mt-1">Terms and conditions for using eloNest</p>
                    </div>
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </a>

                <a href="/legal/security" className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-semibold text-gray-900">Security</h3>
                      <p className="text-sm text-gray-600 mt-1">Our security practices and data protection measures</p>
                    </div>
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </a>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Company Information</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong className="text-gray-900">Company Name:</strong> eloNest Financial Management
                </p>
                <p>
                  <strong className="text-gray-900">Registered Address:</strong><br />
                  123 Business Street<br />
                  Suite 100<br />
                  City, State 12345<br />
                  United States
                </p>
                <p>
                  <strong className="text-gray-900">Contact:</strong><br />
                  Email: legal@elonest.com<br />
                  Phone: 1-800-356-6378
                </p>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
              <p className="text-gray-600">
                All content, features, and functionality of eloNest, including but not limited to text, graphics, logos, 
                icons, images, audio clips, digital downloads, and software, are the exclusive property of eloNest Financial 
                Management and are protected by United States and international copyright, trademark, patent, trade secret, 
                and other intellectual property laws.
              </p>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Questions?</h2>
              <p className="text-gray-600 mb-4">
                If you have any questions about our legal documents or policies, please contact us:
              </p>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">
                Contact Legal Department →
              </a>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default Legal;

